import { ProgressBar } from "primereact/progressbar";
import { useParams } from "react-router-dom";
import CreateUsersComponent from "../../../../component/System/Users/CreateUsers";
import {
  createUser,
  fetchUserRolesDD,
  fetchUsersById,
  initCreateUserScreen,
  updateUser,
  fetchUserCreateMenuList,
  fetchLocationsDD,
} from "../../../../redux/actions/System/Users";
import { connect } from "react-redux";
import { useEffect } from "react";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { setIsformDirty } from "../../../../redux/actions/common/form";
import { getMenuAccess } from "../../../Login/login-utils";

const CreateUsersContainer = (props) => {
  const {
    isLoading,
    fetchUsersById,
    isEdit,
    updateUser,
    createUser,
    isUpdateUserSuccess,
    shouldBlockNavigation,
    isUpdateUserError,
    isUserCreateSuccess,
    isUserCreateError,
    formFieldValueMap,
    isUsersDetailSuccess,
    fetchUserRolesDD,
    UserRolesDD,
    fetchLocationsDD,
    LocationsDD,
    initCreateUserScreen,
    userCreateMenuList,
    fetchUserCreateMenuList,
  } = props;
  const { id } = useParams();

  const callAPIasync = async () => {
    initCreateUserScreen();
    await fetchUserRolesDD();
    await fetchLocationsDD();
    let newData = {};
    newData["userId"] = localStorage.getItem("userId");
    if (newData) {
      await fetchUserCreateMenuList(newData);
    }

    if (isEdit) {
      await fetchUsersById({ id });
    }
  };

  useEffect(() => {
    callAPIasync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  useEffect(() => {
    if (isUserCreateSuccess || isUpdateUserSuccess) {
      shouldBlockNavigation(false);
    }
  }, [isUserCreateSuccess, isUpdateUserSuccess, shouldBlockNavigation]);

  useEffect(() => {
    const refreshMenuAccess = async () => {
      if (isUpdateUserSuccess && isEdit) {
        const loggedInUserId = localStorage.getItem("userId");
        if (loggedInUserId && id === loggedInUserId) {
          const token = localStorage.getItem("token");
          if (token) {
            await getMenuAccess(token, loggedInUserId);
            window.location.reload();
          }
        }
      }
    };
    refreshMenuAccess();
  }, [isUpdateUserSuccess, isEdit, id]);

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  const getToastProps = () => {
    if (isUpdateUserSuccess || isUserCreateSuccess) {
      const toastTitle = isEdit
        ? "User Updated successfully"
        : "User Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (isUpdateUserError || isUserCreateError) {
      let toastTitle = props.error || "Error while updating user";

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const createUsersProps = {
    isEdit,
    formFieldValueMap,
    isUsersDetailSuccess,
    isUpdateUserSuccess,
    isUserCreateSuccess,
    updateUser,
    createUser,
    UserRolesDD,
    LocationsDD,
    fetchUserRolesDD,
    fetchLocationsDD,
    userCreateMenuList,
    initCreateUserScreen,
    shouldBlockNavigation,
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateUsersComponent {...createUsersProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectFromUsersReducer(state, "isLoading"),
    error: selectFromUsersReducer(state, "error"),
    isUsersDetailSuccess: selectFromUsersReducer(state, "isUsersDetailSuccess"),
    formFieldValueMap: selectFromUsersReducer(state, "formFieldValueMap"),
    isUpdateUserSuccess: selectFromUsersReducer(state, "isUpdateUserSuccess"),
    isUpdateUserError: selectFromUsersReducer(state, "isUpdateUserError"),
    isUserCreateSuccess: selectFromUsersReducer(state, "isUserCreateSuccess"),
    isUserCreateError: selectFromUsersReducer(state, "isUserCreateError"),
    UserRolesDD: selectFromUsersReducer(state, "UserRolesDD"),
    LocationsDD: selectFromUsersReducer(state, "LocationsDD"),
    userCreateMenuList: selectFromUsersReducer(state, "userCreateMenuList"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateUserScreen: () => dispatch(initCreateUserScreen()),
    fetchUsersById: (payload) => dispatch(fetchUsersById(payload)),
    updateUser: (payload) => dispatch(updateUser(payload)),
    createUser: (payload) => dispatch(createUser(payload)),
    fetchUserRolesDD: (payload) => dispatch(fetchUserRolesDD(payload)),
    fetchUserCreateMenuList: (payload) =>
      dispatch(fetchUserCreateMenuList(payload)),
    fetchLocationsDD: (payload) => dispatch(fetchLocationsDD(payload)),
    shouldBlockNavigation: (isFormDirty) =>dispatch(setIsformDirty(isFormDirty)),
  };
};

const selectFromUsersReducer = (state, path) => {
  return selectUsersReducer(state)[path];
};

const selectUsersReducer = ({ userReducer }) => {
  return userReducer;
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUsersContainer);
